import classes from "./CompaniesWorkingWith.module.css";
import knackfunding from "../../Assets/Logos/knackfunding.png";
import Match4You from "../../Assets/Logos/Match4You.png";
import IBInnovators from "../../Assets/Logos/IB Innovators.png";
import TheFundedTrader from "../../Assets/Logos/The Funded Trader .png";
import EZL from "../../Assets/Logos/ezl.png";
import elevateTalent from "../../Assets/Logos/elevateTalent.png";
import InstantFinance from "../../Assets/Logos/Instant Finance.png";
import Staffry from "../../Assets/Logos/staffry.png";
import FastCash4Iphone from "../../Assets/Logos/Fastcash4iphones.png";
import powerPosting from "../../Assets/Logos/powerposting.png";
import tms from "../../Assets/Logos/tms.png";
import scorify from "../../Assets/Logos/scorify.png";

const clients = [
  { name: "Knack Funding", src: knackfunding },
  { name: "Match4You", src: Match4You },
  { name: "IB Innovators", src: IBInnovators },
  { name: "The Funded Trader", src: TheFundedTrader },
  { name: "EZL", src: EZL },
  { name: "Instant Finance", src: InstantFinance },
  { name: "Staffry", src: Staffry },
  { name: "Fast Cash 4 iPhones", src: FastCash4Iphone },
  { name: "Elevate Talent", src: elevateTalent },
  { name: "Power Posting", src: powerPosting },
  { name: "TMS", src: tms },
  { name: "Scorify", src: scorify },
];

export default function CompaniesWorkingWith() {
  const speed = 20000;
  const copies = [0, 1, 2];

  return (
    <div className={classes.wrap}>
      <div className={classes.heading}>Trusted by teams we’ve helped grow</div>
      <div className={classes.inner}>
        <div className={classes.wrapper}>
          {copies.map((copy) => (
            <section
              key={copy}
              className={classes.section}
              style={{ "--speed": `${speed}ms` }}
              aria-hidden={copy !== 0}
            >
              {clients.map((client) => (
                <div className={classes.image} key={`${copy}-${client.name}`}>
                  <img
                    src={client.src}
                    alt={copy === 0 ? `${client.name} logo` : ""}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              ))}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
